import Translator from '../../../vendor/translator/translator.js';

global.Translator = Translator;

import translations from '../../../translations/trans_ar.json';
import translationsEditor from '../../../translations/trans_editor_ar.json';

Translator.fromJSON(translations);
Translator.fromJSON(translationsEditor);
